class imageClusterPopup {
  constructor(){
    this.button = document.querySelector('.js-button');
    this.popup = document.querySelector('.js-popup');
    this.close = document.querySelectorAll('.js-close');
    this.closePopup();
    this.openPopup();
  };

  closePopup() {
    this.close.forEach(item => {
      item.addEventListener('click', () => {
        this.popup.classList.remove('open');
        siteOverlay.prototype.hideOverlay();
      })
    })
  }
  openPopup() {
    this.button.addEventListener('click', ()=> {
      siteOverlay.prototype.showOverlay();
      this.popup.classList.add('open');
    })
  }
}

new imageClusterPopup()
